var _desc, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Country/spain") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Country/spain",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spain",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,256 C0,287.314 5.633,317.31 15.923,345.043 L256,367.304 L496.077,345.043 C506.367,317.31 512,287.314 512,256 C512,224.686 506.367,194.69 496.077,166.957 L256,144.696 L15.923,166.957 C5.633,194.69 0,224.686 0,256 Z",
    id: "Path",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.000000, 0.000000)",
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.077,166.957 C444.906,69.473 351.071,0 241,0 C130.929,0 37.094,69.473 0.923,166.957 L481.077,166.957 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.923,345.043 C37.094,442.527 130.929,512 241,512 C351.071,512 444.906,442.527 481.077,345.043 L0.923,345.043 Z",
    id: "Path"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/ES.561f448550de6cff0f5c634b396e1a42.svg";
export { ForwardRef as ReactComponent };